import { Factory } from '../../../services/Factory';

export class DataOverview implements angular.IDirective {
    public restrict = 'E';
    public templateUrl: string;
    public scope = { ngModel: '=' };
    public require = ['ngModel'];

    constructor() {
        this.templateUrl = "partials/reporting/controls/data_overview.html";
    }
}

frontendApp.directive("iioDataOverview", [Factory.Create(DataOverview)]);
